import _ from 'lodash'
import renderFieldDropdown from 'scoreboard/datasets/render-field-dropdown'
import i18n from 'scoreboard/components/i18n'
import selects from 'scoreboard/components/selects'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'

/**
 * Renders the report field dropdown based on whether a dataset or
 * option data was given
 *
 * @param el
 * @param optionData
 * @param {Dataset} [dataset]
 * @param {Integer|String} [selectedId] the selected field id to initialize to, for
 * datasets this is the dataset field id, for non datasets it's the column type
 * @param {Object} options
 * @param {Element|jQuery} options.el the SELECT element in the DOM
 * @param {Array} [options.optionData] the option data
 * @param {Object} [datasetDropdownOptions] extra options to be passed into
 * 				renderFieldDropdown() if a dataset field dropdown is used
 */
function attachFieldDropdown({el, optionData, dataset,
	required, selectedId, datasetDropdownOptions}) {
	if (dataset) {
		let allowedFieldIds = null
		let groups = {}
		if (!_.isNil(optionData) && !_.isEmpty(optionData)) {
			allowedFieldIds = []
			_.each(optionData, option => {
				if (option.group) {
					groups[option.id] = option.group
				}
				allowedFieldIds.push(option.id)
			})
		}


		let selected = selectedId // if no selectedId is passed in, the dropdown is rendered without a chosen field
		return renderFieldDropdown(_.extend({
			el,
			dataset,
			allowedFieldIds,
			required,
			selectOptions: { selected },
			groups
		}, datasetDropdownOptions))
	} else {
		selects.filtering(el, {
			options: optionData.map(o => {
				o.label = i18n.get(o.label)
				o.selected = o.id == selectedId
				o.customIcon = o.icon
				o.value = o.id
				return o
			}),
			groupBy: 'group',
			placeholder: i18n.get('common.startTyping'),
			render: {
				option: d => selects.optionHtml(d),
				item: d => selects.optionHtml(d)
			}
		})
		let markedField = null
		if (required) {
			let options = _.extend({
				el,
				validator: requiredValidator
			})
			markedField = new MarkedField(options).render()
		}
		return markedField
	}
}

export default attachFieldDropdown
attachFieldDropdown.__filename__ = 'reports/common/attach-field-dropdown.js'
